class MixCompose extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.init();
    }
    init() {
        this.setup();
        this.interact();
    }
    setup() {
        if (!getScreenType().isDekstop) {
            this.querySelector('.mix-compose-list-wrap').classList.add('swiper');
            this.querySelector('.mix-compose-list-inner').classList.add('swiper-wrapper');
            this.querySelectorAll('.mix-compose-item').forEach((item) => item.classList.add('swiper-slide'));

            new Swiper(this.querySelector('.mix-compose-list-wrap'), {
                modules: [Navigation, Scrollbar, Pagination],
                slidesPerView: 1,
                spaceBetween: parseRem(16),
                scrollbar: {
                    el: this.querySelector('.mix-compose-list-wrap-scroller-inner'),
                    draggable: true,
                    dragClass: 'mix-compose-list-wrap-scroller-thumb',
                    dragSize: window.innerWidth > 991 ? parseRem(206) : parseRem(103),
                    snapOnRelease: true,
                },
                pagination: {
                    el: this.querySelector('.mix-compose-list-wrap-pagi'),
                    bulletClass: 'mix-compose-list-wrap-pagi-item',
                    bulletActiveClass: 'is-active',
                    clickable: true,
                },
                breakpoints: {
                    768: {
                        slidesPerView: '2.4',
                    }
                }
            })
        }
        const addClassToHeadings = () => {
            const headings = document.querySelectorAll(".mix-compose-item-content h1, .mix-compose-item-content h2, .mix-compose-item-content h3, .mix-compose-item-content h4, .mix-compose-item-content h5, .mix-compose-item-content h6");
            headings.forEach(element => {
                if(element){
                    element.classList.add("txt", "txt-20", "txt-med", "mix-compose-item-title");
                }
            });
            const subHeadings = document.querySelectorAll(".mix-compose-item-content p");
            subHeadings.forEach(element => {
                element.classList.add("txt", "txt-16", "mix-compose-item-sub");
            });
        };
        addClassToHeadings();
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.mix-compose-title-wrap') },
            tweenArr: [
                new RevealTextReset({ el: this.querySelector('.mix-compose-label .txt'), color: 'black' }),
                new RevealTextReset({ el: this.querySelector('.mix-compose-title .txt'), color: 'black' }),
            ],
        });
        this.querySelectorAll('.mix-compose-item').forEach((item) => {
            new MasterTimeline({
                triggerInit: this,
                scrollTrigger: { trigger: item },
                tweenArr: [
                    new ScaleLine({ el: item.querySelector('.div-line') }),
                    new FadeSplitText({ el: item.querySelector('.mix-compose-item-number .txt'), delay: '<=0' }),
                    // new FadeSplitText({ el: item.querySelector('.mix-compose-item-title .txt'), breakType: 'words', delay: '<=0' }),
                    // new FadeSplitText({ el: item.querySelector('.mix-compose-item-sub .txt'), delay: '<=.25' }),
                ...Array.from(item.querySelector('.mix-compose-item-content').querySelectorAll('.txt')).map((el) => new FadeSplitText({ el, delay: "<=.2" })),

                ]
            })
        })
        new MasterTimeline({
            triggerInit: this,
            scrollTrigger: { trigger: this.querySelector('.mix-compose-thumb-inner'), start: "top top+=65%"},
            tweenArr: [
                new ScaleInset({ el: this.querySelector('.mix-compose-thumb-item:nth-child(1)') })
            ]
        });
    }
    interact() {
        let allItems = this.querySelectorAll('.mix-compose-item');
        let heightListItem = this.querySelector('.mix-compose-list-inner').clientHeight;
        console.log(heightListItem)
        gsap.set('.mix-compose-thumb-wrap', {y: allItems[0].offsetTop});
        allItems.forEach((item, index) => {
            item.addEventListener('mouseenter', () => {
                allItems.forEach((item, index) => {
                    item.classList.remove('active');
                });
                item.classList.add('active');
                gsap.set('.mix-compose-thumb-inner', {yPercent: -100 / allItems.length * index});
                gsap.set('.mix-compose-thumb-wrap', {y: allItems[index].offsetTop});
            });
        });
    }
}

customElements.define('mix-compose', MixCompose);